export default __webpack_public_path__ + "static/media/solution-quality.07d79dd7.png";